import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteSocialNetworkCardsComponent } from './website-social-network-cards.component'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  declarations: [WebsiteSocialNetworkCardsComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [WebsiteSocialNetworkCardsComponent]
})
export class WebsiteSocialNetworkCardsModule { }
